import styled from "styled-components";

export const WrapperButtonToTop = styled.button`
  border-radius: 50%;
  border: none;
  bottom: 30px;
  cursor: pointer;
  height: 65px;
  position: fixed;
  right: 0;
  width: 65px;

  svg {
    transform: rotate(180deg);
  }
`;
